/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedeemInviteCommand
 */
export interface RedeemInviteCommand {
    /**
     * 
     * @type {string}
     * @memberof RedeemInviteCommand
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemInviteCommand
     */
    password: string;
}

/**
 * Check if a given object implements the RedeemInviteCommand interface.
 */
export function instanceOfRedeemInviteCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function RedeemInviteCommandFromJSON(json: any): RedeemInviteCommand {
    return RedeemInviteCommandFromJSONTyped(json, false);
}

export function RedeemInviteCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemInviteCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'password': json['password'],
    };
}

export function RedeemInviteCommandToJSON(value?: RedeemInviteCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'password': value.password,
    };
}

